import * as Sentry from '@sentry/vue';
import { defaultRegion, updateFirebaseConnection } from 'boot/firebase';
import { auth as useAuthStore } from 'src/store/auth';

export default {

  setRegionMutation(region) {
    this.region = region || defaultRegion;

    if (region) {
      localStorage.setItem('selected_region', region);
    }
  }, // setRegionMutation()

  initializeStore() {
    this.setRegionMutation(localStorage.getItem('selected_region'));
  }, // initializeStore()

  async setRegion({ region, context }) {
    const previousRegion = this.region;
    const acceptableRegions = this.regionOptions.map((r) => r.value);

    if (acceptableRegions.includes(region) === false) {
      return;
    }

    this.setRegionMutation(region);

    // We cannot reinitialize Sentry for a new region with the current implementation.
    // However, we can deactivate Sentry by stopping event sending to prevent receiving
    // events from the incorrect region.
    if (previousRegion !== region && ['us', 'eu'].includes(previousRegion)) {
      await Sentry.close();
    }
    await updateFirebaseConnection(region);

    if (previousRegion !== region) {
      const auth = useAuthStore();
      await auth.handleAuthStateChanged({ context });
    }
  }, // setRegion()

};
